
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wer kennt das nicht? Man geht an eine Beerdigung, und ein Pfarrer zitiert aus
der Bibel und vernebelt die persönliche Erinnerung mit waghalsigen Behauptungen:
Oder dies: Eine Yogastunde endet mit einer rituellen Verbeugung und einem
ehrfürchtig geflüsterten «Namaste» aus der Hindu-Religion. Oder: Eine Verwandte
erzählt aus ihrem früheren Leben, berichtet von Orten, an denen sie in ihrer
jetzigen Gestalt noch nie war und die sie doch wiedererkannte. Der
Wahrhaftigkeit verpflichtete Kollegen publizieren in ihren Zeitschriften
Horoskope, die Prognosen aufgrund einer jahrzehntelang zurückliegenden
Konstellation der Sterne bei der Geburt. Hokuspokus überall, und dies 300 Jahre
nach der Aufklärung.`}</p>
    <p>{`Dabei ist der Erkenntnisfortschritt der Naturwissenschaften seither
eindrücklich. Der Kosmos: entzaubert als diffuser Raum mit Milliarden von
Galaxien. Die Erde: ein kleiner, bedeutungsloser Planet. Das Atom:
entschlüsselt. Der Mensch: ein intelligenter Affe, seine DNA bis zu 99 Prozent
identisch mit jener anderer Primaten. Sein Hirn: ein Computer. Die
intellektuelle Überlegenheit anderer Computer: eine Frage der Zeit. Der Himmel:
unbewohnbar, leer.`}</p>
    <p>{`Der britische Physiker Stephen Hawking prognostizierte vor seinem Tod im
vergangenen Jahr, dass bis Ende dieses Jahrhunderts alle Rätsel der Astronomie
gelöst sein werden. Gott ist dann ein unpersönlicher Begriff für die
Naturgesetze. Das ist logisch, aber auch trostlos. Nichts sei für den Menschen
so unerträglich wie ein leerer Himmel, sagt der renommierte Schweizer Germanist
Peter von Matt.`}</p>
    <p>{`Und jetzt hat sich der deutsche Philosoph Jürgen Habermas au∏fgemacht, Glauben
und Wissen zu versöhnen. Ohne Hokuspokus, mit gebotenem Res­pekt vor den
Fortschritten der Naturwissenschaften. Die Vorstellung, Gott sei die Summe aller
Naturgesetze, hält Habermas für eine Überschätzung der Naturwissenschaften
(«szientistisch»). Die Überzeugung, Religion sei tot, für eine Überschätzung des
Säkularen («säkularistisch»). Aus dem Versuch, Glauben und Wissen
zusammenzubringen, ist ein grosses philosophisches Werk geworden, eines der
wichtigsten dieses Jahrzehnts. Schade einzig, dass diese andere Geschichte der
Philosophie mit zahlreichen Fachbegriffen codiert ist, auf 1650 Seiten. Hier
eine Übersetzung in die Alltagssprache in sieben Schritten.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;